// removed by extract-text-webpack-plugin
module.exports = {"base":"a209GlK96EuPqpfgZD3Va","detailsTradingFirstCol":"jpA-IeDJl4rBjq5lCx53p","bolderText":"jIRARvtIn-_niqFdFJzT1","estimateUSD":"EZibskSODb-pv22sdm3d6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisGasPrice.scss
// module id = 1247
// module chunks = 0